document.__proto__.sodigital = ((ver) => {
    const o = ["#FFFFFF", "#000000", "#FDD300"], t = t => `color:${o[t]}`, D = (o, t) => { let D = "%c"; for (let I = 0; I < t; I++)D += o; return D }, I = [
        [{"-": 58}], [{"-": 15}, {"#": 27}, {"*": 2}, {"=": 1}, {"-": 13}],
        [{"-": 15}, {"@": 33}, {"#": 1}, {":": 1}, {"-": 8}],
        [{"-": 15}, {"+": 24}, {"#": 1}, {"=": 1}, {"@": 10}, {"*": 1}, {":": 1}, {"-": 5}],
        [{"-": 43}, {".": 1}, {":": 1}, {"@": 8}, {":": 1}, {"-": 4}],
        [{"-": 5}, {":": 1}, {"=": 33}, {":": 1}, {"-": 5}, {":": 1}, {"*": 1}, {"@": 7}, {"$": 1}, {":": 1}, {"-": 2}],
        [{"-": 5}, {":": 1}, {"@": 36}, {":": 1}, {"-": 5}, {":": 1}, {"*": 1}, {"@": 5}, {"$": 1}, {":": 1}, {"-": 1}],
        [{"-": 5}, {":": 1}, {"@": 38}, {":": 1}, {"-": 4}, {":": 1}, {"*": 1}, {"@": 5}, {"#": 1}, {":": 1}],
        [{"-": 36}, {".": 1}, {":": 1}, {"*": 1}, {"@": 6}, {":": 1}, {"-": 4}, {"*": 1}, {"@": 6}, {"#": 1}, {":": 1}],
        [{"-": 37}, {".": 1}, {":": 1}, {"*": 1}, {"@": 6}, {":": 1}, {"-": 4}, {"*": 1}, {"@": 5}, {"#": 1}, {":": 1}],
        [{"-": 0}, {".": 1}, {"@": 16}, {"-": 7}, {"@": 12}, {":": 1}, {"-": 4}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 5}, {"#": 1}, {":": 1}],
        [{"-": 0}, {".": 1}, {"@": 16}, {"-": 7}, {"@": 13}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 5}, {"#": 1}, {":": 1}],
        [{"-": 31}, {".": 1}, {":": 1}, {"*": 1}, {"@": 4}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 4}, {":": 1}, {"-": 10}],
        [{"-": 31}, {".": 1}, {":": 1}, {"*": 1}, {"@": 4}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 4}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 5}, {"#": 1}, {":": 1}],
        [{"-": 3}, {".": 1}, {"=": 26}, {":": 1}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 3}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 11}],
        [{"-": 1}, {".": 1}, {"@": 26}, {":": 1}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 4}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 12}],
        [{"-": 37}, {".": 1}, {":": 1}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 13},],
        [{"-": 35}, {".": 1}, {":": 1}, {"*": 1}, {"@": 5}, {":": 1}, {"-": 15},],
        [{"-": 10}, {"@": 5}, {"-": 4}, {":": 1}, {"@": 21}, {":": 1}, {"-": 17}],
        [{"-": 9}, {"@": 5}, {"-": 3}, {":": 1}, {"@": 21}, {":": 1}, {"-": 19}],

    ];
    console.info((() => {
        let o = ""; for (let t in I) {
            for (let n in I[t])
                for (let A in I[t][n]) o += D(A, I[t][n][A]); o += "\n"
        }
        return o
    }
    )(), t(0),
    t(0), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1), t(1),
    t(0), t(1), t(1), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1),
    t(0), t(1), t(1), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1),
    t(0), t(1), t(1), t(0), t(1), t(1), t(0), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1),
    t(0), t(1), t(1), t(0), t(1), t(1), t(0), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1),
    t(0), t(1), t(1), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(1),
    t(0), t(1), t(1), t(1), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(1), t(1), t(1), t(0), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(1), t(1), t(0),
    t(0), t(1), t(1), t(1), t(1), t(1), t(0),
    t(0), t(1), t(0), t(1), t(1), t(1), t(0),
    t(0), t(1), t(0), t(1), t(1), t(1), t(0),
    ), console.info("https://www.sodigital.mx", ver)
});
